import { render, staticRenderFns } from "./PageStream.vue?vue&type=template&id=f9007fac&"
import script from "./PageStream.vue?vue&type=script&lang=js&"
export * from "./PageStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9007fac')) {
      api.createRecord('f9007fac', component.options)
    } else {
      api.reload('f9007fac', component.options)
    }
    module.hot.accept("./PageStream.vue?vue&type=template&id=f9007fac&", function () {
      api.rerender('f9007fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/stream/PageStream.vue"
export default component.exports